import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { formatarMilhar } from '../../../utils/formatarMilhar'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import Table from '../../Table/index.jsx'

import CancelarPedido from './cancelarPedido'
import ConcluirPedido from './concluirPedido'
import NovoPedido from './novoPedido'
import ProcessarPedido from './processarPedido'

import '../../../css/painelVirtueyes/pedidoSms/pedidoSms.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let pedidosSelecionados = []
let valorLimite = 50

const TableprimaryKey = 'NUMERO_PEDIDO'

function TabelaPedidosSms() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  // const [cdCliente, setCdCliente] = useState(-1)
  // const [dsCliente, setDsCliente] = useState('NULL')
  // const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState([])

  let itensVar = []

  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let revelarProcessarPedido = useSelector(
    (state) => state.virtueyesState.revelarProcessarPedido
  )
  let revelarConcluirPedido = useSelector(
    (state) => state.virtueyesState.revelarConcluirPedido
  )
  let revelarCancelarPedido = useSelector(
    (state) => state.virtueyesState.revelarCancelarPedido
  )
  let novoPedido = useSelector(
    (state) => state.virtueyesState.revelarNovoPedidoSmsVirtueyes
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  const [spinAtivo, setSpinAtivo] = useState(true)

  const despacho = useDispatch()
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(397) // 'pedidoSmsTabelaPedidoSms'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(desabilitarAcoes(true))
    despacho(mudarManejador('tabelaPedidosSms'))
    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/sms_pedido?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post(
            '/m1/filtrar/sms_pedido',
            dados
          )
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/sms_pedido?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, filtros])

  const colunas = [
    {
      dataField: 'CODIGO_CLIENTE',
      headerClasses: 'nao-selecionavel',
      text: 'Cód. cliente',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'RAZAO_SOCIAL',
      headerClasses: 'nao-selecionavel',
      text: 'Razão social',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'NOME_FANTASIA',
      headerClasses: 'nao-selecionavel',
      text: 'Nome fantasia',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'USUARIO_EMAIL',
      headerClasses: 'nao-selecionavel',
      text: 'Usuário solicitante',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'NUMERO_PEDIDO',
      headerClasses: 'nao-selecionavel',
      text: 'ID do pedido',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'PEDIDO_STATUS',
      headerClasses: 'nao-selecionavel',
      text: 'Status',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'CONTA',
      headerClasses: 'nao-selecionavel',
      text: 'Conta',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'QTD_SMS',
      headerClasses: 'nao-selecionavel',
      text: 'Quantidade de SMS',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell !== '' && cell !== undefined ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'VALOR',
      headerClasses: 'nao-selecionavel',
      text: 'Valor',
      sort: true,
      formatter: (cell) => {
        const valor = parseFloat(cell)
        return (
          <div className="fonte-cor-1 label-tabela-1 container-valor-pedido">
            {' '}
            {!valor || isNaN(valor) ? (
              <>
                <p className="valor-rs-pedido">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedido"> 0.00 </p>
              </>
            ) : (
              <>
                <p className="valor-rs-pedido">R$</p>{' '}
                <p className="fonte-cor-1 valor-pedido">
                  {' '}
                  {formatarMilhar(valor)}
                </p>
              </>
            )}{' '}
          </div>
        )
      }
    },
    {
      dataField: 'DATA_PEDIDO',
      headerClasses: 'nao-selecionavel',
      text: 'Data do pedido',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    }
  ]

  function handleSelecionarTodosPedidos() {
    ColetaClickstream(402) // 'pedidoSmsTabelaPedidoSmsHandleSelecionarTodosPedidos'
    itens.map((item, i) => {
      if (itens[i].NUMERO_PEDIDO) {
        pedidosSelecionados.push(itens[i])
      }
    })
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarTodosPedidos() {
    ColetaClickstream(403) // 'pedidoSmsTabelaPedidoSmsHandleDesselecionarTodosPedidos'
    pedidosSelecionados = []
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(false))
  }

  function handleSelecionarPedido(pedido) {
    ColetaClickstream(404) // 'pedidoSmsTabelaPedidoSmsHandleSelecionarPedido'
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].NUMERO_PEDIDO === pedido) {
        pedidosSelecionados.push(itens[i])
        break
      }
    }
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarPedido(pedido) {
    ColetaClickstream(405) // 'pedidoSmsTabelaPedidoSmsHandleDesselecionarPedido'
    for (let i = 0; i < pedidosSelecionados.length; i++) {
      if (pedidosSelecionados[i].NUMERO_PEDIDO === pedido) {
        pedidosSelecionados.splice(i, 1)
        break
      }
    }
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(false))
  }

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/sms_pedido?contar=true&buscar=' + conteudoBusca
      )
    } else {
      const dados = {
        paguinaAtual: contador,
        carregarLimit: valorLimite,
        buscar: conteudoBusca,
        filtros: filtros,
        contar: true
      }
      apiData = await api_gateway.post('/m1/filtrar/sms_pedido', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    pedidosSelecionados = []
    setPaginaAtual(1)
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados((prev) => [...prev, row[TableprimaryKey]])

      handleSelecionarPedido(row.NUMERO_PEDIDO)
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => id !== row[TableprimaryKey])
      )
      handleDesselecionarPedido(row.NUMERO_PEDIDO)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      const allIds = rows.map((r) => r[TableprimaryKey])
      setItensSelecionados((prev) => [...prev, ...allIds])

      handleSelecionarTodosPedidos()
    } else {
      setItensSelecionados((prev) =>
        prev.filter((id) => !rows.some((r) => r[TableprimaryKey] === id))
      )

      handleDesselecionarTodosPedidos()
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados,
          modeSelection: 'checkbox',
          handleOnSelect,
          handleOnSelectAll
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {/* {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={() =>
                setRevelarMensagemSucesso(!revelarMensagemSucesso)
              }
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={'O cliente ' + dsCliente + ','}
              mensagemParagrafo2={'cód. ' + cdCliente + ' foi carregado.'}
              mensagemBotao="OK"
            />
          </div>
        </div>
      )} */}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {novoPedido === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovoPedido
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              itensSelecionados={pedidosSelecionados}
            />
          </div>
        </div>
      )}
      {revelarProcessarPedido === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <ProcessarPedido
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              itensSelecionados={pedidosSelecionados}
            />
          </div>
        </div>
      )}
      {revelarConcluirPedido === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <ConcluirPedido
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              itensSelecionados={pedidosSelecionados}
            />
          </div>
        </div>
      )}
      {revelarCancelarPedido === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CancelarPedido
              renderizar={renderizar}
              setRenderizar={setRenderizar}
              itensSelecionados={pedidosSelecionados}
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
export default connect(mapStateToProps)(React.memo(TabelaPedidosSms))
